<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Adicionar Curso" />
    </div>
    <!-- Substituir a linha do título -->
<span class="title">{{ unidadeOrganica ? 'Editar Unidade Orgânica' : 'Adicionar Unidade Orgânica' }}</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()">
    </p-button>
  </div>
  <form [formGroup]="unidadeOrganicaForm" (ngSubmit)="save()">

    <div class="p-fluid grid">
      <div class="field col-12">
        <div class="file-upload">
          <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
            accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000" invalidFileTypeMessageSummary="danger"
            invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido" invalidFileLimitMessageSummary="danger"
            invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
            <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
              let-uploadCallback="uploadCallback">
            </ng-template>
            <ng-template #content let-files let-uploadedFiles="uploadedFiles"
              let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
              let-removeUploadedFileCallback="removeUploadedFileCallback">
              <a class="circular-upload preview"
                [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                <span *ngIf="!imagePreview">Foto</span>
                <div class="icon" (click)="choose($event, chooseCallback)">
                  <img src="icons/camera-01.svg" alt="">
                </div>
              </a>
              <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
            </ng-template>
            <ng-template #file></ng-template>
            <ng-template #empty></ng-template>
          </p-fileupload>
        </div>
      </div>

      <div class="field col-6">
        <label for="tipoInstituicaoEnsinoID">Tipo</label>
        <p-select formControlName="tipoInstituicaoEnsinoID"
          [options]="[{ label: TypeOfinstituicao, value: tipoInstituicaoEnsinoValueEnum }]" [disabled]="true"
          placeholder="Tipo de Instituição" class="w-full pr-4"/>
        <div
          *ngIf="unidadeOrganicaForm.get('tipoInstituicaoEnsinoID')?.touched && unidadeOrganicaForm.get('tipoInstituicaoEnsinoID')?.invalid">
          <small class="error-message"
            *ngIf="unidadeOrganicaForm.get('tipoInstituicaoEnsinoID')?.errors?.['required']">Tipo é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="nif">Número de Identificação</label>
        <div class="flex align-items-center relative">
          <input id="nif" type="text" class="w-full pr-4" pInputText formControlName="numIdentificacao"
            placeholder="Informe o NIF" />
          <button pButton *ngIf="unidadeOrganicaForm && isInternalInstitution"
            [disabled]="unidadeOrganicaForm.get('numIdentificacao')?.invalid" type="button" icon="pi pi-search"
            class="search-btn" (click)="searchNif()" aria-label="Search"></button>
        </div>
        <div
          *ngIf="unidadeOrganicaForm.get('numIdentificacao')?.touched && unidadeOrganicaForm.get('numIdentificacao')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('numIdentificacao')?.errors?.['required']">Número
            de Identificação é
            obrigatório.</small>
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('numIdentificacao')?.errors?.['minlength']">Número
            de Identificação deve
            ter no mínimo {{unidadeOrganicaForm.get('numIdentificacao')?.errors?.['minlength'].requiredLength}}
            caracteres.</small>
        </div>
      </div>

      <!-- Nome -->
      <div class="field col-12">
        <label for="designacao">Nome</label>
        <input id="designacao" type="text" class="w-full" pInputText formControlName="nome" placeholder="Nome da "
          [disabled]="unidadeOrganicaForm.get('nome')?.disabled ?? false" />

        <div *ngIf="unidadeOrganicaForm.get('nome')?.touched && unidadeOrganicaForm.get('nome')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('nome')?.errors?.['required']">Nome é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="email">E-mail</label>
        <input id="email" type="email" class="w-full" pInputText formControlName="email" placeholder="E-mail"
          [disabled]="unidadeOrganicaForm.get('email')?.disabled ?? false" />
        <div *ngIf="unidadeOrganicaForm.get('email')?.touched && unidadeOrganicaForm.get('email')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('email')?.errors?.['required']">E-mail é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="phone">Telefone da </label>
        <input id="telefone" type="text" class="w-full" pInputText formControlName="telefone" placeholder="Telefone" />
        <div *ngIf="unidadeOrganicaForm.get('telefone')?.touched && unidadeOrganicaForm.get('telefone')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('telefone')?.errors?.['required']">Telefone
            é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="country">País</label>
        <p-select [showClear]="true" [filter]="true" appendTo="body" id="paisID" class="w-full" optionLabel="designacao"
          optionValue="id" [options]="countries" placeholder="Seleccione o país" formControlName="paisID" />
      </div>

      <div class="field col-6">
        <label for="province">Província ou Estado</label>
        <p-select [showClear]="true" [filter]="true" appendTo="body" id="provinciaID" class="w-full"
          optionLabel="designacao" optionValue="id" [options]="provinces" placeholder="Seleccione a província"
          formControlName="provinciaEstadoID" />
        <div
          *ngIf="unidadeOrganicaForm.get('provinciaEstadoID')?.touched && unidadeOrganicaForm.get('provinciaEstadoID')?.invalid">
          <small class="error-message"
            *ngIf="unidadeOrganicaForm.get('provinciaEstadoID')?.errors?.['required']">Província ou Estado
            é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="municipality">Município</label>
        <p-select [showClear]="true" [filter]="true" appendTo="body" id="municipioID" class="w-full"
          optionLabel="designacao" optionValue="id" [options]="municipalities" placeholder="Seleccione o município"
          formControlName="municipioID" />
        <div *ngIf="unidadeOrganicaForm.get('municipioID')?.touched && unidadeOrganicaForm.get('municipioID')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('municipioID')?.errors?.['required']">Município é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="address">Endereço </label>
        <input id="endereco" type="text" class="w-full" pInputText formControlName="endereco" placeholder="Endereço"
          [disabled]="unidadeOrganicaForm.get('endereco')?.disabled ?? false" />
        <div *ngIf="unidadeOrganicaForm.get('endereco')?.touched && unidadeOrganicaForm.get('endereco')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('endereco')?.errors?.['required']">Endereço
            é
            obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="sigla">Sigla </label>
        <input id="sigla" type="text" class="w-full" pInputText formControlName="sigla" placeholder="Sigla" />
        <div *ngIf="unidadeOrganicaForm.get('sigla')?.touched && unidadeOrganicaForm.get('sigla')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('sigla')?.errors?.['required']">Sigla
            é
            obrigatório.</small>
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('sigla')?.errors?.['minlength']">Sigla deve
            ter no mínimo {{unidadeOrganicaForm.get('sigla')?.errors?.['minlength'].requiredLength}}
            caracteres.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="natureza">Natureza </label>
        <p-select [filter]="false" appendTo="body" id="natureza" class="w-full" optionLabel="designacao"
          optionValue="id" [options]="naturezaOptions" placeholder="Seleccione a natureza" formControlName="natureza" />
        <div *ngIf="unidadeOrganicaForm.get('natureza')?.touched && unidadeOrganicaForm.get('natureza')?.invalid">
          <small class="error-message" *ngIf="unidadeOrganicaForm.get('natureza')?.errors?.['required']">Natureza
            é
            obrigatório.</small>
        </div>
      </div>

    </div>
    <div class="modal-footer flex justify-content-between mt-0 pt-0">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()">
      </button>
      <button pButton type="submit" [label]="unidadeOrganica ? 'Actualizar' : 'Adicionar'" class="p-button-primary"></button>
    </div>
  </form>
</div>
<p-toast></p-toast>